import {
  unstable_defaultDirectiveFormatter,
  type Unstable_DirectiveFormatter,
} from "@assistant-ui/react";
import { sanitizeMentionLabel } from "@/lib/mentions/referenceTypes";

/**
 * Same parse rules as assistant-ui default; sanitize labels on serialize so chips with
 * {@code ]}/{/} do not corrupt directive text before POST /chat composition.
 */
export const cnsDirectiveFormatter: Unstable_DirectiveFormatter = {
  serialize(item) {
    return unstable_defaultDirectiveFormatter.serialize({
      ...item,
      label: sanitizeMentionLabel(item.label ?? ""),
    });
  },
  parse(text) {
    return unstable_defaultDirectiveFormatter.parse(text);
  },
};
